
export default {
  name: 'AllContentAccordion',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    allContent: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
}
